import './App.scss';
import Introduction from './components/Introduction/Introduction';
import Parallax from './components/Parallax/Parallax';
import Projects from './components/Projects/Projects';
import Work from './components/Work/Work';
import Contact from './components/Contact/Contact';
import Sidebar from './components/Sidebar/Sidebar';

function App() {
  return (
    <div className="App">
      <Sidebar />
      <main>
        <section id="Home" className="page-section page-section--hero">
          <Introduction />
        </section>
        <section id="Projects" className="page-section page-section--parallax">
          <Parallax
            kicker="Selected systems"
            title="Projects"
            description="Production platforms, AI workflows, and personal tools with clear reliability stories."
            tags={['Micro-frontends', 'Agentic AI', 'Event delivery']}
          />
        </section>
        <section id="project-details" className="page-section page-section--content">
          <Projects />
        </section>
        <section id="Work" className="page-section page-section--parallax">
          <Parallax
            kicker="EagleView"
            title="Experience"
            description="From intern to Software Engineer II, with scope across platforms, agents, validation, deliverables, and map products."
          />
        </section>
        <section id="work-details" className="page-section page-section--content">
          <Work />
        </section>
        <section id="Contact" className="page-section page-section--parallax">
          <Parallax
            kicker="Toolbox"
            title="Contact"
            description="Frontend systems, backend reliability, geospatial workflows, and AI orchestration."
          />
        </section>
        <section id="contact-details" className="page-section page-section--content page-section--last">
          <Contact />
        </section>
      </main>
    </div>
  );
}

export default App;
